import { j as t, S as e } from "../chunks/index2.mjs";
import { A as x, u as m } from "../chunks/index2.mjs";
import { c as s } from "../chunks/index.mjs";
function p({ children: r, locale: o }) {
  return /* @__PURE__ */ t.jsx(s.AirportProvider, { supportedLocales: e, locale: o, fallbackLocale: "ko", children: r });
}
export {
  p as AirportProvider,
  x as AnchorContextProvider,
  m as useAnchorContext
};
